import React, { useCallback, useState } from "react";
import "../../styles/Unauthorized/signup.scss";
import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { Button, Form, Input, message } from "antd";
import axios from "axios";
import { AUTH_TOKEN, REACT_APP_API, REACT_APP_API_TENANTS_URL } from "../../constants";
import { useNavigate } from "react-router";
import { getUserDetails } from "../../service/appService";
import { setLocalStorage } from "../../utils/helpers";
import { showCustomError } from "../../utils/notificationService";

function Login() {
  const [IsLoading, setIsLoading] = useState(false);
  const [notification, setNotification] = message.useMessage();
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const handleUserDetailsSuccess = useCallback(
    (data) => {
      if (data?.Validation === true && data?.Status === "Success") {
        setLocalStorage("UserRole", data?.UserRole);
        setLocalStorage("UserName", data?.Username);
        setLocalStorage("userId", data?.UserID);
        setLocalStorage("DomainId", data?.DomainID);
        setLocalStorage("OrgId", data?.OrgID);
        setTimeout(() => {
          navigate("/org/dashboard")
        }, 200);
      }
    },
    [navigate],
  );

  const handleUserDetailsFailure = useCallback((response) => {
    showCustomError("User Details", "unable to fetch user details")
  }, []);

  const handleFinish = (values) => {
    const loginData = {
      ...values,
    };
    setIsLoading(true);

    axios
      .post(`${REACT_APP_API}/authentication/okta/orgLogin`, loginData)
      .then((res) => {
        setLocalStorage("token", res.data.token);
        setIsLoading(false);
        getUserDetails({ param: {}, onSuccess: handleUserDetailsSuccess, onFailure: handleUserDetailsFailure });
      })
      .catch((err) => {
        setIsLoading(false);
        console.error("handleFinish failed:", err?.response?.status, err?.message);
        if (err.response.data.code === 401) {
          notification.open({
            type: "error",
            content: "User not registered,Please create an account",
          });
        } else {
          notification.open({
            type: "error",
            content: "Unable to login, Please try again later ",
          });
        }
      });
  };

  const fetchOrgDetail = (value) => {
    let data = {
      email: value.email,
    };

    axios
      .post(`${REACT_APP_API_TENANTS_URL}/orgdetail`, data, {
        headers: {
          withCredentials: true,
          "X-Authorization": AUTH_TOKEN(),
        },
      })
      .then((res) => {
        if (res.data.check_authentication === false) {
          navigate("/tenant/add");
        } else {
          navigate("/org/dashboard");
        }
      });
  };

  const fetchTenent = (values) => {
    let data = {
      email: values.email,
    };
    setIsLoading(true);
    axios
      .post(`${REACT_APP_API_TENANTS_URL}/tenantlist`, data, {
        headers: {
          withCredentials: true,
        },
      })
      .then((res) => {
        setIsLoading(false);
        let tenant = res?.data?.data;
        if (tenant.length < 1) {
          navigate("/tenant/add");
        } else {
          navigate("/org/dashboard");
        }
      })
      .catch((err) => {
        setIsLoading(false);

        console.error("fetchTenent failed:", err?.response?.status, err?.message);
      });
  };

  return (
    <>
      {setNotification}
      <div className="login-container">
        <div className="login-box">
          <h2 className="title">Sign in to Organization</h2>

          <Form
            form={form}
            name="normal_login"
            className="login-form"
            initialValues={{
              remember: true,
            }}
            onFinish={handleFinish}
          >
            <Form.Item
              name="username"
              rules={[
                {
                  required: true,
                  message: "Please input your Email",
                },
                {
                  type: "email",
                  message: "Please enter valid email",
                },
              ]}
            >
              <Input size="large" prefix={<UserOutlined className="site-form-item-icon" />} placeholder="Email" />
            </Form.Item>
            <Form.Item
              name="password"
              rules={[
                {
                  required: true,
                  message: "Please input your Password",
                },
              ]}
            >
              <Input.Password size="large" prefix={<LockOutlined className="site-form-item-icon" />} type="password" placeholder="Password" />
            </Form.Item>

            <div className="login-form-button">
              <Form.Item>
                <Button size="large" type="primary" htmlType="submit" className="login-form-button" loading={IsLoading}>
                  Sign in
                </Button>
                <br />
              </Form.Item>
              <span>Or</span> <br />
              <br />
              <a href="/tenant/forgot-password">Forgot password ?</a>
              <br />
            </div>
          </Form>
        </div>
        <div className="login-box" style={{ marginTop: "1rem" }}>
          <p className="login-form-button" style={{ fontSize: "14px" }}>
            Don't have an account ?{" "}
            <span
              style={{
                color: "#1677ff",
                backgroundColor: "transparent",
                textDecoration: "none",
                outline: "none",
                transition: "color 0.3s",
                fontSize: "14px",
                cursor: "pointer",
              }}
              onClick={() => navigate("/org/signup")}
            >
              Sign up
            </span>
          </p>
        </div>
      </div>
    </>
  );
}

export default Login;
